import { useCallback } from "react";

export const useZendeskWidget = () => {
  const openWidget = useCallback(() => {
    if (!window.zE || typeof window.zE !== "function") return;
    window.zE("messenger", "open");

    window.zE("messenger", "show");
  }, []);
  return {
    isInitialized: window.zE && typeof window.zE === "function",
    openWidget,
  };
};
